import type { ClickstreamPayload } from './types';
import { defineTracker } from '@zg-rentals/rentals-analytics';
import { event } from '@zillow/universal-analytics';

export const tracker = defineTracker<ClickstreamPayload<Record<string, unknown>>>((payload, instrument) => {
  const modifiedPayload = {
    ...payload,
    envelope: {
      ...payload.envelope,
      // add this here so every event definition in app code doesn't need to
      event_client_start_dtm: new Date().toISOString(),
    },
  };

  event(modifiedPayload);
  instrument(payload.envelope.event_type_id);
});
